
function Contact() {
    return (
      <section id="contact" className="contact">
        <h2>Contact Me</h2>
        <p>Email: reply2aryankapoor@gmail.com</p>
        <div className="social-links">
            <a href="https://www.linkedin.com/in/aryan-kapoor22/">LinkedIn</a>
          <a href="https://github.com/AryanKpr">GitHub</a>
        </div>
      </section>
    );
  }
  
  export default Contact;